export default __webpack_public_path__ + "static/media/customer10.b804f002.jpg";